import { FIREBASE_STORAGE_URL } from "../../app-settings";
import { CardElementName } from "../../models/CardElement"
import { classNamesOrEmpty } from "../../style/common";
import "../../style/icons.css";

export type ElementIconProps = {
    element: CardElementName,
    className?: string | undefined
}

export function ElementIcon(props: ElementIconProps) {
    return (
        <img
            title={props.element}
            src={`${FIREBASE_STORAGE_URL}/images/icons/${props.element}.svg`}
            alt={`${props.element} image`}
            className={`h-[18px] w-[18px]`} />
    )
}